.container {
  user-select: none;
}

.strictInput {
  border-top: 1px solid #d9d9d9;
  margin-top: 1rem;
  padding-top: 1rem;
}

.warning {
  color: red;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 1rem;
}

.modalFooter {
  gap: 1rem;
}
